import React from 'react'

const CommonSection = ({ children }) => {
  return (
    <div className="max-w-[1240px] max_xl:max-w-[980px] m-auto mt-[100px] max_md:mt-10 max_sm:mt-[50px] max_md:px-10 max_sm:px-5">{children}</div>
  );
};

export default CommonSection